import React from 'react';

export default function LanguagesImage(props?: SVGProps) {
	return (
		<svg
			strokeWidth='1.5'
			viewBox='0 0 24 24'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...props}>
			<path
				d='M10 17L9.33334 17C8.22877 17 7.33334 16.1047 7.33334 15.0002C7.33334 14.3284 7.33334 13.6211 7.33333 13.1111C7.33333 12.5556 6 12 6 12C6 12 7.33333 11.4444 7.33334 10.8889C7.33334 10.4359 7.33334 9.70586 7.33334 8.99998C7.33334 7.89541 8.22877 7 9.33334 7L10 7'
				className='theme-stroke'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'></path>
			<path
				d='M14 17L14.6667 17C15.7712 17 16.6667 16.1047 16.6667 15.0002C16.6667 14.3284 16.6667 13.6211 16.6667 13.1111C16.6667 12.5556 18 12 18 12C18 12 16.6667 11.4444 16.6667 10.8889C16.6667 10.4359 16.6667 9.70586 16.6667 8.99998C16.6667 7.89541 15.7712 7 14.6667 7L14 7'
				className='theme-stroke'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'></path>
			<path
				d='M21 3.6V20.4C21 20.7314 20.7314 21 20.4 21H3.6C3.26863 21 3 20.7314 3 20.4V3.6C3 3.26863 3.26863 3 3.6 3H20.4C20.7314 3 21 3.26863 21 3.6Z'
				className='theme-stroke'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'></path>
		</svg>
	);
}
